@if (!canView()) {
  <div class="fq-card fuseqCard mt-3">
    <div class="fq-card-body fuseqCardBody">
      <div class="px-4 py-14 text-center">
        <fa-icon [icon]="['fas', 'person-digging']" class="mb-3 block text-3xl text-fq-primary" aria-hidden="true"></fa-icon>
        <div class="text-xl font-bold text-fq-heading">Work in progress</div>
        <p class="mx-auto mt-2 max-w-md text-sm text-fq-text-muted">
          La scheda sede è in fase di preparazione e sarà disponibile prossimamente.
        </p>
      </div>
    </div>
  </div>
} @else if (!fraz() && !frazInput()) {
  <div class="fq-card fuseqCard mt-3">
    <div class="fq-card-header fuseqCardHeader">SEDI</div>
    <div class="fq-card-body fuseqCardBody">
      <div class="px-4 py-5">
        <p class="mb-4 text-sm text-fq-text-muted">
          Apri la scheda di una sede: stato SDWAN/RTU, timeline eventi, ticket, perimetro e dispositivi.
        </p>
        <div class="flex flex-wrap items-end gap-3">
          <div class="w-full min-w-0 flex-1">
            <label class="mb-1 block text-sm font-medium text-fq-text-2" for="hub-site">Frazionario / sede</label>
            <p-select inputId="hub-site" [options]="sites()" optionLabel="label" optionValue="value"
              [filter]="true" filterBy="label" [virtualScroll]="true" [virtualScrollItemSize]="36"
              [(ngModel)]="selectedSite" placeholder="Cerca per frazionario o denominazione…"
              appendTo="body" class="w-full"></p-select>
          </div>
          <button type="button" class="fq-btn fq-btn-primary" [disabled]="!selectedSite" (click)="openSite()">
            <fa-icon [icon]="['fas', 'location-dot']" aria-hidden="true"></fa-icon>
            Apri scheda
          </button>
        </div>
      </div>
    </div>
  </div>
} @else if (loading()) {
  <div class="px-4 py-12 text-center text-sm text-fq-text-muted">
    <fa-icon [icon]="['fas', 'spinner']" animation="spin" class="mr-2" aria-hidden="true"></fa-icon>
    Caricamento sede…
  </div>
} @else if (error()) {
  <div class="mx-1 mt-3 rounded-lg border border-fq-danger/30 bg-fq-danger/10 px-3 py-2 text-sm text-fq-danger">{{ error() }}</div>
} @else if (overview()) {
  @if (overview(); as o) {

  @if (o.warnings.length > 0) {
    <div class="mt-3 rounded-lg border border-fq-warning/30 bg-fq-warning/10 px-3 py-2 text-xs text-fq-warning">
      <div class="flex items-start gap-2">
        <fa-icon [icon]="['fas', 'triangle-exclamation']" class="mt-0.5" aria-hidden="true"></fa-icon>
        <div class="min-w-0 flex-1">
          <div class="leading-snug">
            <span class="font-semibold">Dati non disponibili ({{ o.warnings.length }}):</span>
            {{ warningLabels() }}. La scheda mostra il resto.
          </div>
          @if (warningDetails(); as details) {
            <ul class="mt-1 grid gap-0.5">
              @for (detail of details; track $index) {
                <li class="leading-snug">
                  <span class="font-semibold">{{ detail.label }}</span>
                  <span> — {{ detail.message }}</span>
                </li>
              }
            </ul>
          }
        </div>
      </div>
    </div>
  }

  <!-- Header sede -->
  <div class="fq-card fuseqCard mt-3">
    <div class="fq-card-body fuseqCardBody">
      <div class="flex flex-wrap items-start justify-between gap-3 px-4 py-4">
        <div class="min-w-0">
          <div class="flex flex-wrap items-center gap-2">
            <span class="fq-badge fq-badge-primary text-sm">{{ o.site.fraz }}</span>
            <span class="text-lg font-bold text-fq-heading">{{ o.site.denominazione || 'Sede' }}</span>
          </div>
          <div class="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-fq-text-muted">
            @if (o.site.comune) { <span>{{ o.site.comune }}@if (o.site.sigla_provincia) { ({{ o.site.sigla_provincia }}) }</span> }
            @if (o.site.filiale) { <span>· Filiale {{ o.site.filiale }}</span> }
            @if (o.site.polo) { <span>· Polo {{ o.site.polo }}</span> }
            @if (o.site.id_anagrafica) { <span>· ID {{ o.site.id_anagrafica }}</span> }
          </div>
          @if (siteSdbTags().length) {
            <div class="mt-2 flex flex-wrap items-center gap-1.5">
              <span class="text-[10px] font-semibold uppercase tracking-wide text-fq-text-muted">Tag SDB</span>
              <fuseq-sdb-tags [tags]="siteSdbTags()"></fuseq-sdb-tags>
            </div>
          }
        </div>
        <div class="grid w-full grid-cols-2 gap-2 sm:flex sm:w-auto sm:flex-wrap">
          <button type="button" class="fq-btn fq-btn-outline-primary" (click)="copyLink()">
            <fa-icon [icon]="['fas', 'link']" aria-hidden="true"></fa-icon> Copia link
          </button>
          @if (!embedded()) {
            <a class="fq-btn fq-btn-outline-primary" [routerLink]="['/awp/site-timeline']" [queryParams]="{ fraz: o.site.fraz }">
              <fa-icon [icon]="['fas', 'timeline']" aria-hidden="true"></fa-icon> Timeline
            </a>
            <a class="fq-btn fq-btn-outline-primary" [routerLink]="['/perimetro-awp']" [queryParams]="{ fraz: o.site.fraz }">
              <fa-icon [icon]="['fas', 'network-wired']" aria-hidden="true"></fa-icon> Perimetro
            </a>
          }
          <button type="button" class="fq-btn fq-btn-primary" (click)="openTicketDialog()">
            <fa-icon [icon]="['fas', 'plus']" aria-hidden="true"></fa-icon> Apri ticket
          </button>
        </div>
      </div>

      <!-- Stato immediato della sede: tecnologia, migrazione SDWAN e NRD -->
      <div class="grid gap-2 border-t border-fq-border-faint px-4 py-3 sm:grid-cols-3">
        <div class="hub-status" [ngClass]="technologyStatusClass()">
          <fa-icon [icon]="technologyIcon()" aria-hidden="true"></fa-icon>
          <div class="min-w-0">
            <div class="hub-status-label">Tecnologia SDWAN</div>
            <div class="hub-status-value">{{ technologyLabel() }}@if (cella(); as cell) { - {{ cell }} }</div>
          </div>
        </div>
        <div class="hub-status" [ngClass]="sdwanStatusClass()">
          <fa-icon [icon]="sdwanStatusIcon()" aria-hidden="true"></fa-icon>
          <div class="min-w-0">
            <div class="hub-status-label">Migrazione SDWAN</div>
            <div class="hub-status-value">{{ sdwanStatusLabel() }}</div>
            @if (sdwanStatusDetail()) {
              <div class="hub-status-detail">{{ sdwanStatusDetail() }}</div>
            }
          </div>
        </div>
        <div class="hub-status" [ngClass]="nrdStatusClass()">
          <fa-icon [icon]="nrdStatusIcon()" aria-hidden="true"></fa-icon>
          <div class="min-w-0">
            <div class="hub-status-label">Migrazione NRD</div>
            <div class="hub-status-value">{{ nrdStatusLabel() }}</div>
            @if (nrdStatusDetail()) {
              <div class="hub-status-detail">{{ nrdStatusDetail() }}</div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Alert operativi -->
  @if (blocking()) {
    <div class="mt-3 flex flex-wrap items-center gap-2 rounded-lg border border-fq-danger/30 bg-fq-danger/10 px-3 py-2 text-sm text-fq-danger">
      <fa-icon [icon]="['fas', 'triangle-exclamation']" aria-hidden="true"></fa-icon>
      <span class="font-semibold">RTU in blocco</span>
      <span class="text-xs">Verifica la sede e chiudi il blocco al termine.</span>
      <button type="button" class="fq-btn fq-btn-danger ml-auto max-sm:ml-0 max-sm:w-full" [disabled]="closingBlocking()" (click)="closeBlocking()">
        {{ closingBlocking() ? 'Chiusura…' : 'Chiudi blocco' }}
      </button>
    </div>
  }
  @if (nrdConstraint()) {
    <div class="mt-2 flex flex-wrap items-center gap-2 rounded-lg border border-fq-warning/30 bg-fq-warning/10 px-3 py-2 text-xs text-fq-warning">
      <fa-icon [icon]="['fas', 'calendar-days']" aria-hidden="true"></fa-icon>
      <span class="font-semibold">Vincolo NRD</span>
      <span>{{ formatDateOnly(nrdConstraint()) }}</span>
    </div>
  }

  <!-- KPI -->
  <div class="mt-3 grid gap-3 md:grid-cols-2 xl:grid-cols-3">
    <!-- RTU -->
    <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3">
      <div class="mb-2 flex items-center justify-between gap-2">
        <div class="flex min-w-0 items-center gap-2">
          <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">RTU</span>
          <span class="fq-badge" [ngClass]="healthClass()" [title]="health().reasons.join(' · ')">{{ health().label }}</span>
        </div>
        <fa-icon [icon]="['fas', 'server']" class="text-fq-text-muted" aria-hidden="true"></fa-icon>
      </div>
      @if (o.rtu.row; as r) {
        <div class="text-sm font-semibold text-fq-text">{{ r.ip || 'Senza IP' }}</div>
        <div class="mt-1 flex flex-wrap items-center gap-1.5">
          @if (o.rtu.lastPing; as p) {
            <span class="fq-badge" [ngClass]="p.state === 'online' ? 'fq-badge-success' : 'fq-badge-danger'">{{ p.state || '—' }}</span>
          }
          @if (o.rtu.uptime30; as u) {
            <span class="text-xs text-fq-text-muted">uptime 30gg: <b>{{ u.pct }}%</b> · {{ u.offlineSpans }} span</span>
          }
        </div>
        <div class="mt-1 text-xs text-fq-text-muted">Installata: {{ formatDateOnly(r.installedAt) }}</div>
      } @else {
        <div class="mt-2 text-sm text-fq-text-muted">Nessuna RTU censita</div>
      }
    </div>

    <!-- Speedtest -->
    <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3">
      <div class="mb-2 flex items-center justify-between">
        <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Ultimo speedtest</span>
        <fa-icon [icon]="['fas', 'gauge-high']" class="text-fq-text-muted" aria-hidden="true"></fa-icon>
      </div>
      @if (o.speedtest; as s) {
        <div class="flex items-baseline gap-3">
          <span class="text-xl font-bold text-fq-text">{{ formatSpeed(s.download) }}<span class="ml-0.5 text-xs font-medium text-fq-text-muted">Mbps ↓</span></span>
          <span class="text-xl font-bold text-fq-text">{{ formatSpeed(s.upload) }}<span class="ml-0.5 text-xs font-medium text-fq-text-muted">Mbps ↑</span></span>
        </div>
        <div class="mt-1 flex flex-wrap items-center gap-1.5">
          <span class="fq-badge" [ngClass]="statusClass(s.status)">{{ s.status || '—' }}</span>
          <span class="text-xs text-fq-text-muted">{{ s.tecnologia || '' }} · {{ formatDate(s.startedAt) }}</span>
        </div>
      } @else {
        <div class="mt-2 text-sm text-fq-text-muted">Nessun test disponibile</div>
      }
    </div>

    <!-- Tunnel live -->
    <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3">
      <div class="mb-2 flex flex-wrap items-center justify-between gap-2">
        <div class="flex flex-wrap items-center gap-2">
          <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Tunnel · live</span>
          @if (liveTunnels(); as lt) {
            @if (lt.source) { <span class="fq-badge fq-badge-secondary">{{ liveTunnelsSourceLabel() }}</span> }
            @if (lt.tunnels.length > 0) {
              <span class="fq-badge" [ngClass]="lt.allUp ? 'fq-badge-success' : 'fq-badge-danger'">{{ lt.allUp ? 'tutti up' : 'anomalie' }}</span>
            }
          }
        </div>
        <button type="button" class="fq-btn fq-btn-outline-primary fq-btn-sm" [disabled]="liveTunnelsLoading()" (click)="loadLiveTunnels(true)">
          @if (liveTunnelsLoading()) {
            <fa-icon [icon]="['fas', 'spinner']" animation="spin" aria-hidden="true"></fa-icon>
          } @else {
            <fa-icon [icon]="['fas', 'rotate']" aria-hidden="true"></fa-icon>
          }
          Verifica live
        </button>
      </div>

      @if (liveTunnelsLoading()) {
        <div class="py-3 text-sm text-fq-text-muted">Interrogazione apparato in corso…</div>
      } @else if (liveTunnels(); as lt) {
        @if (lt.error) {
          <div class="mb-2 text-xs text-fq-warning">Errore apparato: {{ cleanText(lt.error) }}</div>
        }
        @if (lt.tunnels.length > 0) {
          <fq-tunnel-status [tunnels]="lt.tunnels"></fq-tunnel-status>
        } @else {
          <div class="text-sm text-fq-text-muted">Nessun tunnel restituito dall'apparato.</div>
        }
        @if (lt.checkedAt) {
          <div class="mt-2 text-[10px] text-fq-text-muted">Verificato {{ formatDate(lt.checkedAt) }}</div>
        }
      } @else {
        <div class="text-sm text-fq-text-muted">Premi «Verifica live» per interrogare l'apparato.</div>
      }
    </div>
  </div>

  <!-- Sezioni: pill nav con icone (contenitore unico con il contenuto) -->
  <fq-dialog-nav class="mt-3 block" [sections]="tabs()" [active]="tab()"
    (activeChange)="onNavChange($event)" variant="pill" enclosed>

  @switch (tab()) {
    @case ('timeline') {
      <app-site-timeline [frazInput]="siteFraz()" [embedded]="true" [rtuFilter]="true"></app-site-timeline>
    }

    @case ('tickets') {
      <div class="mt-3">
        @if (o.tickets.list.length === 0) {
          <div class="rounded-xl border border-dashed border-fq-border px-4 py-8 text-center text-sm text-fq-text-muted">
            Nessun ticket collegato a questa sede.
          </div>
        } @else {
          <div class="grid gap-2">
            @for (ticket of o.tickets.list; track ticket.id) {
              <div class="rounded-lg border border-fq-border-soft bg-fq-surface p-3"
                [class.cursor-pointer]="canManage()" tabindex="0" role="button"
                (click)="openTicket(ticket.id)" (keyup.enter)="openTicket(ticket.id)"
                (keydown.space)="openTicket(ticket.id); $event.preventDefault()">
                <div class="flex flex-wrap items-center gap-2">
                  <span class="fq-badge" [ngClass]="ticketBadgeClass(ticket.status)">{{ ticketStatusLabel(ticket.status) }}</span>
                  <span class="text-xs font-semibold text-fq-text-muted">#{{ ticket.id }}</span>
                  @if (ticket.assignee) { <span class="text-xs text-fq-text-muted">· {{ ticket.assignee }}</span> }
                  <span class="ml-auto text-xs text-fq-text-muted">{{ formatDate(ticket.createdAt) }}</span>
                </div>
                <div class="mt-1 text-sm font-semibold text-fq-text">{{ ticket.title }}</div>
              </div>
            }
          </div>
        }
      </div>
    }

    @case ('perimetro') {
      <div class="mt-3 grid gap-3 md:grid-cols-2 xl:grid-cols-3">
        <!-- SDWAN: tecnologia, cella e date -->
        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3">
          <div class="mb-2">
            <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">SDWAN</span>
          </div>

          @if (!o.sdwan.fortinet && !o.sdwan.cisco) {
            <div class="text-sm text-fq-text-muted">Nessun dato SDWAN per questa sede.</div>
          } @else {
            <div class="grid gap-3">
              @if (o.sdwan.fortinet; as f) {
                <div>
                  <div class="grid grid-cols-2 gap-x-4 gap-y-2">
                    <div class="hub-info-item"><span class="hub-info-label">Tecnologia</span><span class="hub-info-value">Fortinet</span></div>
                    <div class="hub-info-item"><span class="hub-info-label">Cella</span><span class="hub-info-value">{{ f.cella || '—' }}</span></div>
                    <div class="hub-info-item"><span class="hub-info-label">Installazione pianificata</span><span class="hub-info-value">{{ formatDateOnly(f.installPlanned) }}</span></div>
                    <div class="hub-info-item"><span class="hub-info-label">Installazione</span><span class="hub-info-value">{{ formatDateOnly(f.installedAt) }}</span></div>
                    <div class="hub-info-item"><span class="hub-info-label">Migrazione pianificata</span><span class="hub-info-value">{{ formatDateOnly(f.migrationPlanned) }}</span></div>
                    <div class="hub-info-item"><span class="hub-info-label">Migrazione</span><span class="hub-info-value">{{ formatDateOnly(f.migratedAt) }}</span></div>
                  </div>
                  @if (f.error) { <div class="hub-note text-fq-warning">Errore: {{ cleanText(f.error) }}</div> }
                </div>
              }

              @if (o.sdwan.cisco; as c) {
                <div [class.border-t]="o.sdwan.fortinet" [class.border-fq-border-faint]="o.sdwan.fortinet" [class.pt-3]="o.sdwan.fortinet">
                  <div class="grid grid-cols-2 gap-x-4 gap-y-2">
                    <div class="hub-info-item"><span class="hub-info-label">Tecnologia</span><span class="hub-info-value">Cisco</span></div>
                    <div class="hub-info-item"><span class="hub-info-label">Cella</span><span class="hub-info-value">{{ c.cella || '—' }}</span></div>
                    <div class="hub-info-item"><span class="hub-info-label">Installazione pianificata</span><span class="hub-info-value">{{ formatDateOnly(c.installPlanned) }}</span></div>
                    <div class="hub-info-item"><span class="hub-info-label">Installazione</span><span class="hub-info-value">{{ formatDateOnly(c.installedAt) }}</span></div>
                    <div class="hub-info-item"><span class="hub-info-label">Migrazione pianificata</span><span class="hub-info-value">{{ formatDateOnly(c.migrationPlanned) }}</span></div>
                    <div class="hub-info-item"><span class="hub-info-label">Migrazione</span><span class="hub-info-value">{{ formatDateOnly(c.migratedAt) }}</span></div>
                  </div>
                  @if (c.error) { <div class="hub-note text-fq-warning">Errore: {{ cleanText(c.error) }}</div> }
                </div>
              }
            </div>
          }
        </div>

        <!-- NRD -->
        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3">
          <div class="mb-2 flex flex-wrap items-center gap-2">
            <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">NRD</span>
            @if (o.nrd?.status) { <span class="fq-badge" [ngClass]="statusClass(o.nrd?.status)">{{ o.nrd?.status }}</span> }
            @if (nrdConstraint(); as constraintAt) {
              <span class="fq-badge fq-badge-warning" [title]="'Vincolo NRD al ' + formatDateOnly(constraintAt)">Vincolato</span>
            }
          </div>
          @if (o.nrd; as n) {
            <div class="grid grid-cols-2 gap-x-4 gap-y-2">
              <div class="hub-info-item"><span class="hub-info-label">Pianificazione</span><span class="hub-info-value">{{ formatDateOnly(n.planned) }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Migrazione</span><span class="hub-info-value">{{ formatDateOnly(n.migratedAt) }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Router cessati</span><span class="hub-info-value">{{ n.routerCessati ?? '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Linee cessate</span><span class="hub-info-value">{{ n.lineeCessate ?? '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Carrier</span><span class="hub-info-value">{{ n.carrier || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Linee attivate</span><span class="hub-info-value">{{ n.lineeAttivate ?? '—' }}</span></div>
            </div>
            @if (n.note) { <div class="hub-note">{{ cleanText(n.note) }}</div> }
          } @else {
            <div class="text-sm text-fq-text-muted">NRD non in perimetro.</div>
          }
        </div>

        <!-- RTU -->
        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3">
          <div class="mb-2 flex flex-wrap items-center gap-2">
            <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">RTU</span>
            @if (o.rtu.lastPing?.state) {
              <span class="fq-badge" [ngClass]="o.rtu.lastPing?.state === 'online' ? 'fq-badge-success' : 'fq-badge-danger'">{{ o.rtu.lastPing?.state }}</span>
            }
          </div>
          @if (o.rtu.row; as r) {
            <div class="hub-info-grid">
              <div class="hub-info-item"><span class="hub-info-label">Installazione</span><span class="hub-info-value">{{ formatDateOnly(r.installedAt) }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Esito</span><span class="hub-info-value">{{ r.esito || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Ultimo stato</span><span class="hub-info-value">{{ formatDate(o.rtu.lastPing?.since) }}</span></div>
            </div>
          } @else {
            <div class="text-sm text-fq-text-muted">Nessuna RTU censita.</div>
          }
        </div>

      </div>
    }

    @case ('circuiti') {
      <div class="mt-3 grid gap-3 xl:grid-cols-2">
        <!-- Circuito NRD -->
        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3">
          <div class="mb-2 flex flex-wrap items-center gap-2">
            <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Circuito NRD</span>
            @if (o.nrd?.status) { <span class="fq-badge" [ngClass]="statusClass(o.nrd?.status)">{{ o.nrd?.status }}</span> }
          </div>
          @if (o.nrd; as n) {
            <div class="hub-info-grid">
              <div class="hub-info-item"><span class="hub-info-label">Circuito</span><span class="hub-info-value font-mono">{{ n.circuito || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Carrier</span><span class="hub-info-value">{{ n.carrier || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Tecnologia</span><span class="hub-info-value">{{ n.tecnologia || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Tipologia sede</span><span class="hub-info-value">{{ n.tipologiaSede || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Pianificazione</span><span class="hub-info-value">{{ formatDateOnly(n.planned) }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Migrazione</span><span class="hub-info-value">{{ formatDateOnly(n.migratedAt) }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Indirizzo UP</span><span class="hub-info-value">{{ n.addressUp || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Indirizzo DUP</span><span class="hub-info-value">{{ n.addressDup || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Indirizzo FAX</span><span class="hub-info-value">{{ n.addressFax || '—' }}</span></div>
            </div>
            @if (n.note) { <div class="hub-note">{{ cleanText(n.note) }}</div> }
          } @else {
            <div class="text-sm text-fq-text-muted">Nessun circuito NRD per questa sede.</div>
          }
        </div>

        <!-- SIM -->
        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3">
          <div class="mb-2 flex flex-wrap items-center gap-2">
            <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">SIM</span>
            <span class="fq-badge fq-badge-secondary">{{ sims().length }}</span>
          </div>
          @if (sims().length === 0) {
            <div class="text-sm text-fq-text-muted">Nessuna SIM censita.</div>
          } @else {
            <div class="overflow-x-auto">
              <table class="w-full text-left text-xs">
                <thead>
                  <tr class="text-fq-text-muted">
                    <th class="py-1 pr-3 font-semibold">Tecnologia</th>
                    <th class="py-1 pr-3 font-semibold">Apparato</th>
                    <th class="py-1 pr-3 font-semibold">SIM</th>
                    <th class="py-1 pr-3 font-semibold">TGU</th>
                    <th class="py-1 font-semibold">Switch</th>
                  </tr>
                </thead>
                <tbody>
                  @for (sim of sims(); track sim.sim) {
                    <tr class="border-t border-fq-border-faint">
                      <td class="whitespace-nowrap py-1 pr-3">{{ sim.technology }}</td>
                      <td class="whitespace-nowrap py-1 pr-3 font-semibold text-fq-text-2">{{ sim.device }}</td>
                      <td class="whitespace-nowrap py-1 pr-3 font-mono">{{ sim.sim }}</td>
                      <td class="whitespace-nowrap py-1 pr-3 font-mono">{{ sim.tgu || '—' }}</td>
                      <td class="whitespace-nowrap py-1 font-mono">{{ sim.switchIp || '—' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>

        <!-- Linee cessate dalla coda NRD -->
        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3 xl:col-span-2">
          <div class="mb-2 flex flex-wrap items-center gap-2">
            <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Linee cessate NRD</span>
            <span class="fq-badge fq-badge-secondary">{{ ceasedLines().length }}</span>
          </div>
          @if (ceasedLines().length === 0) {
            <div class="text-sm text-fq-text-muted">Nessuna linea cessata registrata.</div>
          } @else {
            <div class="overflow-x-auto">
              <table class="w-full text-left text-xs">
                <thead>
                  <tr class="text-fq-text-muted">
                    <th class="py-1 pr-3 font-semibold">Linea</th>
                    <th class="py-1 pr-3 font-semibold">Carrier</th>
                    <th class="py-1 pr-3 font-semibold">Cessazione</th>
                    <th class="py-1 font-semibold">Richiesta</th>
                  </tr>
                </thead>
                <tbody>
                  @for (line of ceasedLines(); track line.id) {
                    <tr class="border-t border-fq-border-faint">
                      <td class="whitespace-nowrap py-1 pr-3 font-mono text-fq-text-2">{{ line.line || '—' }}</td>
                      <td class="whitespace-nowrap py-1 pr-3">{{ line.carrier || '—' }}</td>
                      <td class="whitespace-nowrap py-1 pr-3">{{ line.ceasedAt ? formatDate(line.ceasedAt) : '—' }}</td>
                      <td class="whitespace-nowrap py-1">{{ line.requestedAt ? formatDate(line.requestedAt) : '—' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>

        <!-- Linee VoIP (Voip_Linee) -->
        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3 xl:col-span-2">
          <div class="mb-2 flex flex-wrap items-center gap-2">
            <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Linee VoIP</span>
            <span class="fq-badge fq-badge-secondary">{{ voipLines().length }} linee</span>
            @if (voipLoading()) {
              <fa-icon [icon]="['fas', 'spinner']" animation="spin" class="text-fq-text-muted" aria-hidden="true"></fa-icon>
            }
          </div>
          @if (voipError() && voipLines().length === 0) {
            <div class="text-xs text-fq-warning">{{ voipError() }}</div>
          } @else if (voipLines().length === 0) {
            <div class="text-sm text-fq-text-muted">{{ voipLoading() ? 'Caricamento linee VoIP…' : 'Nessuna linea VoIP censita.' }}</div>
          } @else {
            <div class="overflow-x-auto">
              <table class="w-full text-left text-xs">
                <thead>
                  <tr class="text-fq-text-muted">
                    <th class="py-1 pr-3 font-semibold">Linea</th>
                    <th class="py-1 pr-3 font-semibold">NIP</th>
                    <th class="py-1 pr-3 font-semibold">Tipo</th>
                    <th class="py-1 pr-3 font-semibold">Carrier</th>
                    <th class="py-1 pr-3 font-semibold">Stato</th>
                    <th class="py-1 pr-3 font-semibold">Installazione</th>
                    <th class="py-1 pr-3 font-semibold">Migrazione</th>
                    <th class="py-1 pr-3 font-semibold">Cessazione</th>
                    <th class="py-1 font-semibold">Operazione</th>
                  </tr>
                </thead>
                <tbody>
                  @for (line of voipLines(); track line.Linea || line.NIP || $index) {
                    <tr class="border-t border-fq-border-faint">
                      <td class="whitespace-nowrap py-1 pr-3 font-semibold text-fq-text-2">{{ line.Linea || '—' }}</td>
                      <td class="whitespace-nowrap py-1 pr-3 font-mono">{{ line.NIP || '—' }}</td>
                      <td class="whitespace-nowrap py-1 pr-3">{{ line.TipoLinea || '—' }}</td>
                      <td class="whitespace-nowrap py-1 pr-3">{{ line.Carrier || '—' }}</td>
                      <td class="py-1 pr-3">
                        <span class="fq-badge" [ngClass]="statusClass(line.Classification)">{{ line.Classification || '—' }}</span>
                      </td>
                      <td class="whitespace-nowrap py-1 pr-3">{{ formatDateOnly(line.DataInstallazione) }}</td>
                      <td class="whitespace-nowrap py-1 pr-3">{{ formatDateOnly(line.DataMigrazione) }}</td>
                      <td class="whitespace-nowrap py-1 pr-3">{{ formatDateOnly(line.DataCessazione) }}</td>
                      <td class="whitespace-nowrap py-1">{{ line.Operazione || '—' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    }

    @case ('speedtest') {
      <div class="mt-3">
        <app-speedtest-history-table [frazionario]="siteFraz()"></app-speedtest-history-table>
      </div>
    }

    @case ('metafield') {
      <div class="mt-3 grid gap-3">
        @if (o.metafield && (hasVlanFields() || metafieldOtherEntries().length > 0)) {
          @if (hasVlanFields()) {
            <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-4" data-testid="hub-vlan-card">
              <app-vlan-table [fields]="o.metafield.fields" [code]="o.metafield.code" />
            </div>
          }

          @if (metafieldOtherEntries().length > 0) {
            <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-4">
              <div class="mb-3 flex flex-wrap items-center gap-2">
                <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Altri metafield</span>
                <span class="text-xs text-fq-text-muted">{{ o.metafield.code }}</span>
              </div>
              <div class="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
                @for (field of metafieldOtherEntries(); track field.key) {
                  <div class="min-w-0 rounded-lg border border-fq-border-faint bg-fq-surface-subtle px-3 py-2">
                    <div class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">{{ field.label }}</div>
                    @if (field.bool !== null) {
                      <span class="fq-badge mt-1" [ngClass]="field.bool ? 'fq-badge-success' : 'fq-badge-secondary'">{{ field.value }}</span>
                    } @else {
                      <div class="mt-0.5 break-words text-sm text-fq-text-2" [class.whitespace-pre-wrap]="field.multiline">{{ field.value }}</div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        } @else {
          <div class="rounded-xl border border-dashed border-fq-border px-4 py-8 text-center text-sm text-fq-text-muted">
            Nessun metafield per questa sede.
          </div>
        }
      </div>
    }

    @case ('workflow') {
      <div class="mt-3 rounded-xl border border-fq-border-soft bg-fq-surface p-3">
        <div class="mb-2 flex flex-wrap items-center justify-between gap-2">
          <div>
            <div class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Esegui template</div>
            <div class="text-xs text-fq-text-muted">Lancia un workflow direttamente sul frazionario {{ siteFraz() }}.</div>
          </div>
          <span class="fq-badge fq-badge-primary">{{ siteFraz() }}</span>
        </div>

        @if (workflowTemplatesLoading()) {
          <div class="text-sm text-fq-text-muted">Caricamento template...</div>
        } @else if (workflowTemplates().length) {
          <div class="flex w-full flex-wrap items-center gap-2">
            <select
              class="fq-form-control w-full min-w-0 flex-1 sm:min-w-72"
              [ngModel]="selectedWorkflowTemplateId()"
              (ngModelChange)="selectedWorkflowTemplateId.set($event)">
              @for (template of workflowTemplates(); track template.id) {
                <option [value]="template.id">
                  {{ template.name }}{{ template.isSystem ? ' · Sistema' : '' }} · {{ template.steps.length }} step
                </option>
              }
            </select>
            <button
              type="button"
              class="fq-btn fq-btn-success max-sm:w-full"
              [disabled]="workflowRunStarting() || !workflowCatalogReady() || !selectedWorkflowTemplateId()"
              (click)="runWorkflowTemplateForSite()">
              @if (workflowRunStarting()) {
                <i class="fa-solid fa-spinner fa-spin"></i> Avvio...
              } @else {
                <i class="fa-solid fa-play"></i> Esegui
              }
            </button>
          </div>
        } @else {
          <div class="text-sm text-fq-text-muted">Nessun template disponibile.</div>
        }
      </div>

      <div class="mt-3">
        <app-mediation-runs [frazFilter]="siteFraz()"></app-mediation-runs>
      </div>
    }

    @case ('dispositivi') {
      <div class="mt-3 grid gap-3 md:grid-cols-2">
        @if (o.sdwan.fortinet; as f) {
          <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3">
            <div class="mb-2 flex flex-wrap items-center justify-between gap-2">
              <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Fortinet</span>
              <span class="fq-badge fq-badge-primary">Fortigate / FEX</span>
            </div>
            <div class="grid gap-3">
              <div>
                <div class="mb-1 text-xs font-semibold text-fq-text-2">Fortigate</div>
                <div class="hub-info-grid">
                  <div class="hub-info-item"><span class="hub-info-label">Seriale</span><span class="hub-info-value font-mono">{{ f.fortigate || '—' }}</span></div>
                  <div class="hub-info-item"><span class="hub-info-label">Hostname</span><span class="hub-info-value font-mono">{{ f.fgHostname || '—' }}</span></div>
                  <div class="hub-info-item"><span class="hub-info-label">IP</span><span class="hub-info-value font-mono">{{ f.ip || '—' }}</span></div>
                </div>
              </div>
              <div class="border-t border-fq-border-faint pt-3">
                <div class="mb-1 text-xs font-semibold text-fq-text-2">FEX</div>
                <div class="hub-info-grid">
                  <div class="hub-info-item"><span class="hub-info-label">Seriale</span><span class="hub-info-value font-mono">{{ f.fex || '—' }}</span></div>
                  <div class="hub-info-item"><span class="hub-info-label">Hostname</span><span class="hub-info-value font-mono">{{ f.fexHostname || '—' }}</span></div>
                  <div class="hub-info-item"><span class="hub-info-label">IP</span><span class="hub-info-value font-mono">{{ f.fexIp || '—' }}</span></div>
                </div>
              </div>
              <div class="border-t border-fq-border-faint pt-3">
                <div class="mb-1 text-xs font-semibold text-fq-text-2">SIM</div>
                <div class="hub-info-grid">
                  <div class="hub-info-item"><span class="hub-info-label">SIM</span><span class="hub-info-value font-mono">{{ f.sim || '—' }}</span></div>
                  <div class="hub-info-item"><span class="hub-info-label">TGU</span><span class="hub-info-value font-mono">{{ f.tgu || '—' }}</span></div>
                </div>
              </div>
            </div>
          </div>
        }

        @if (o.sdwan.cisco; as c) {
          <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3">
            <div class="mb-2 flex flex-wrap items-center justify-between gap-2">
              <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Cisco</span>
              <span class="fq-badge fq-badge-primary">CiscoEdge</span>
            </div>
            <div class="hub-info-grid">
              <div class="hub-info-item"><span class="hub-info-label">CiscoEdge</span><span class="hub-info-value font-mono">{{ c.ciscoEdge || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Hostname</span><span class="hub-info-value font-mono">{{ c.edgeHostname || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Chassis</span><span class="hub-info-value font-mono">{{ c.chassisNumber || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">SIM</span><span class="hub-info-value font-mono">{{ c.sim || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">TGU</span><span class="hub-info-value font-mono">{{ c.tgu || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">Switch</span><span class="hub-info-value font-mono">{{ c.switchIp || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">IP gestione 1</span><span class="hub-info-value font-mono">{{ c.ip1 || '—' }}</span></div>
              <div class="hub-info-item"><span class="hub-info-label">IP gestione 2</span><span class="hub-info-value font-mono">{{ c.ip2 || '—' }}</span></div>
            </div>
          </div>
        }

        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3">
          <div class="mb-2 text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">RTU</div>
          @if (o.rtu.row; as r) {
            <div class="grid gap-1 text-xs text-fq-text-2">
              <div>IP: <b>{{ r.ip || '—' }}</b> · MAC: <b>{{ r.mac || '—' }}</b></div>
              <div>Switch: <b>{{ r.switch || '—' }}</b> / porta <b>{{ r.porta || '—' }}</b></div>
              <div>Installazione: <b>{{ formatDateOnly(r.installedAt) }}</b> · Esito: <b>{{ r.esito || '—' }}</b></div>
              @if (o.rtu.lastPing; as p) {
                <div>Ultimo stato: <b class="uppercase">{{ p.state || '—' }}</b> dal {{ formatDate(p.since) }} ({{ p.checks }} check)</div>
              }
              @if (o.rtu.uptime30; as u) {
                <div>Uptime 30gg: <b>{{ u.pct }}%</b> · {{ u.offlineSpans }} interruzioni</div>
              }
            </div>
          } @else {
            <div class="text-sm text-fq-text-muted">Nessuna RTU censita.</div>
          }
        </div>

        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3 md:col-span-2">
          <div class="mb-2 text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Apparati di rete</div>
          @if (devicesLoading()) {
            <div class="text-sm text-fq-text-muted">Caricamento apparati…</div>
          } @else if (siteDevices().length === 0) {
            <div class="text-sm text-fq-text-muted">Nessun apparato censito.</div>
          } @else {
            <div class="flex flex-wrap gap-1.5">
              @for (device of siteDevices(); track device.uuid || device.sn || device.Hostname) {
                <span class="fq-badge" [ngClass]="deviceBadgeClass(device.Status)" [title]="deviceLabel(device)">
                  {{ device.Tecnologia }} · {{ device.Status === 'up' ? 'up' : device.Status === 'down' ? 'down' : '?' }}
                </span>
              }
            </div>
          }
        </div>

        <!-- Telefoni VoIP installati (RequestVoip) -->
        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3 md:col-span-2">
          <div class="mb-2 flex flex-wrap items-center gap-2">
            <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Telefoni VoIP</span>
            <span class="fq-badge fq-badge-secondary">{{ voipInstalledCount() }} installati / {{ voipAssets().length }}</span>
            @if (voipLoading()) {
              <fa-icon [icon]="['fas', 'spinner']" animation="spin" class="text-fq-text-muted" aria-hidden="true"></fa-icon>
            }
          </div>
          @if (voipError() && voipAssets().length === 0) {
            <div class="text-xs text-fq-warning">{{ voipError() }}</div>
          } @else if (voipAssets().length === 0) {
            <div class="text-sm text-fq-text-muted">{{ voipLoading() ? 'Caricamento telefoni VoIP…' : 'Nessun telefono VoIP censito.' }}</div>
          } @else {
            <div class="overflow-x-auto">
              <table class="w-full text-left text-xs">
                <thead>
                  <tr class="text-fq-text-muted">
                    <th class="py-1 pr-3 font-semibold">Asset</th>
                    <th class="py-1 pr-3 font-semibold">Seriale</th>
                    <th class="py-1 pr-3 font-semibold">PTNumber</th>
                    <th class="py-1 pr-3 font-semibold">Telefono</th>
                    <th class="py-1 pr-3 font-semibold">Installazione</th>
                    <th class="py-1 pr-3 font-semibold">Esito</th>
                    <th class="py-1 font-semibold">Note</th>
                  </tr>
                </thead>
                <tbody>
                  @for (asset of voipAssets(); track asset.IDGUID || asset.Seriale || asset.Telefono || $index) {
                    <tr class="border-t border-fq-border-faint">
                      <td class="py-1 pr-3">
                        <div class="font-semibold text-fq-text-2">{{ asset.DescrizioneAsset || asset.Direttiva || 'Asset' }}</div>
                        @if (isVoipInstalled(asset)) {
                          <span class="fq-badge fq-badge-success">installato</span>
                        }
                      </td>
                      <td class="whitespace-nowrap py-1 pr-3 font-mono text-fq-text-2">{{ asset.Seriale || '—' }}</td>
                      <td class="whitespace-nowrap py-1 pr-3">{{ asset.PTNumber || '—' }}</td>
                      <td class="whitespace-nowrap py-1 pr-3">{{ asset.Telefono || '—' }}</td>
                      <td class="whitespace-nowrap py-1 pr-3">{{ formatDateOnly(asset.DataInstallazionePianificata) }}</td>
                      <td class="py-1 pr-3">
                        <span class="fq-badge" [ngClass]="statusClass(asset.Esito)">{{ asset.Esito || '—' }}</span>
                      </td>
                      <td class="py-1 text-fq-text-muted">
                        @if (cleanText(asset.Note)) {
                          <span class="block max-w-[18rem] whitespace-normal" [pTooltip]="cleanText(asset.Note)" tooltipPosition="top" appendTo="body">{{ cleanText(asset.Note) }}</span>
                        } @else {
                          —
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>

        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3 md:col-span-2">
          <div class="mb-2 flex flex-wrap items-center gap-2">
            <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Sonde 2N e Fax server</span>
            @if (voipLoading()) {
              <fa-icon [icon]="['fas', 'spinner']" animation="spin" class="text-fq-text-muted" aria-hidden="true"></fa-icon>
            }
          </div>
          @if (voipError() && voipSondes().length === 0 && voipFaxes().length === 0) {
            <div class="text-xs text-fq-warning">{{ voipError() }}</div>
          } @else {
            <div class="grid gap-4">
              <div>
                <div class="mb-1 text-xs font-semibold text-fq-text-2">Sonde 2N <span class="text-fq-text-muted">({{ voipSondes().length }})</span></div>
                @if (voipSondes().length === 0) {
                  <div class="text-sm text-fq-text-muted">Nessuna sonda 2N censita.</div>
                } @else {
                  <div class="overflow-x-auto">
                    <table class="w-full text-left text-xs">
                      <thead>
                        <tr class="text-fq-text-muted">
                          <th class="py-1 pr-3 font-semibold">Seriale</th>
                          <th class="py-1 pr-3 font-semibold">SysName</th>
                          <th class="py-1 pr-3 font-semibold">IP</th>
                          <th class="py-1 pr-3 font-semibold">MAC</th>
                          <th class="py-1 pr-3 font-semibold">SIM</th>
                          <th class="py-1 pr-3 font-semibold">ISDN</th>
                          <th class="py-1 font-semibold">Cessazione</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (sonda of voipSondes(); track sonda.Id || sonda.Seriale || $index) {
                          <tr class="border-t border-fq-border-faint">
                            <td class="whitespace-nowrap py-1 pr-3 font-mono text-fq-text-2">{{ sonda.Seriale || sonda.Code || '—' }}</td>
                            <td class="whitespace-nowrap py-1 pr-3">{{ sonda.SysName || '—' }}</td>
                            <td class="whitespace-nowrap py-1 pr-3 font-mono">{{ sonda.IPAddress || '—' }}</td>
                            <td class="whitespace-nowrap py-1 pr-3 font-mono">{{ sonda.MAC || '—' }}</td>
                            <td class="whitespace-nowrap py-1 pr-3">{{ sonda.NumeroSIM || sonda.SerialeSIM || '—' }}</td>
                            <td class="whitespace-nowrap py-1 pr-3">{{ sonda.LineaISDN || '—' }}</td>
                            <td class="whitespace-nowrap py-1">{{ formatDateOnly(sonda.DataCessazione) }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </div>
              <div class="border-t border-fq-border-faint pt-3">
                <div class="mb-1 text-xs font-semibold text-fq-text-2">Fax server <span class="text-fq-text-muted">({{ faxesSorted().length }})</span></div>
                @if (faxesSorted().length === 0) {
                  <div class="text-sm text-fq-text-muted">Nessun fax server censito.</div>
                } @else {
                  <div class="overflow-x-auto">
                    <table class="w-full text-left text-xs">
                      <thead>
                        <tr class="text-fq-text-muted">
                          <th class="py-1 pr-3 font-semibold">Numero</th>
                          <th class="py-1 pr-3 font-semibold">Email</th>
                          <th class="py-1 pr-3 font-semibold">RTG</th>
                          <th class="py-1 pr-3 font-semibold">Carrier</th>
                          <th class="py-1 pr-3 font-semibold">Config</th>
                          <th class="py-1 font-semibold">Invio config</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (fax of faxesSorted(); track fax.Id || fax.Telefono || $index) {
                          <tr class="border-t border-fq-border-faint">
                            <td class="whitespace-nowrap py-1 pr-3 font-mono text-fq-text-2">{{ fax.FaxNumber || fax.Telefono || fax.Code || '—' }}</td>
                            <td class="py-1 pr-3">{{ fax.Email || '—' }}</td>
                            <td class="whitespace-nowrap py-1 pr-3">{{ fax.RTG || '—' }}</td>
                            <td class="whitespace-nowrap py-1 pr-3">{{ fax.Carrier || '—' }}</td>
                            <td class="py-1 pr-3">
                              <span class="fq-badge" [ngClass]="statusClass(fax.ConfigOK)">{{ fax.ConfigOK || '—' }}</span>
                            </td>
                            <td class="whitespace-nowrap py-1">{{ formatDateOnly(fax.DataInvioConfig) }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3 md:col-span-2">
          <div class="mb-2 flex flex-wrap items-center justify-between gap-2">
            <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Ping · ultimi {{ pingWindowDays }} giorni</span>
            @if (o.rtu.uptime30; as u) {
              <span class="text-xs text-fq-text-muted">uptime <b>{{ u.pct }}%</b> · {{ u.offlineSpans }} interruzioni</span>
            }
          </div>
          @if (pingLoading()) {
            <div class="py-3 text-sm text-fq-text-muted">Caricamento…</div>
          } @else if (pingFlow().length === 0) {
            <div class="py-3 text-sm text-fq-text-muted">Nessun dato di ping nel periodo.</div>
          } @else {
            <div class="relative h-6 w-full overflow-hidden rounded-full bg-fq-surface-muted">
              @for (segment of pingFlow(); track segment.key) {
                <div class="absolute top-0 h-full" [style.left.%]="segment.left" [style.width.%]="segment.width"
                  [ngClass]="segment.state === 'offline' ? 'bg-fq-danger' : 'bg-fq-success'" [title]="segment.title"></div>
              }
            </div>
            <div class="mt-1 flex justify-between text-[10px] text-fq-text-muted">
              <span>{{ pingWindowFrom() }}</span>
              <span>oggi</span>
            </div>
            <div class="mt-2 flex flex-wrap items-center gap-3 text-[11px] text-fq-text-muted">
              <span class="inline-flex items-center gap-1"><span class="inline-block h-2 w-2 rounded-full bg-fq-success"></span> online</span>
              <span class="inline-flex items-center gap-1"><span class="inline-block h-2 w-2 rounded-full bg-fq-danger"></span> offline</span>
            </div>
            @if (recentSpans().length > 0) {
              <div class="mt-3 grid gap-1">
                @for (span of recentSpans(); track $index) {
                  <div class="flex flex-wrap items-center gap-2 text-xs">
                    <span class="fq-badge" [ngClass]="span.stato === 'offline' ? 'fq-badge-danger' : 'fq-badge-success'">{{ span.stato === 'offline' ? 'offline' : 'online' }}</span>
                    <span class="text-fq-text-2">{{ formatDate(span.inizio) }} → {{ span.fine ? formatDate(span.fine) : 'in corso' }}</span>
                    <span class="text-fq-text-muted">· {{ spanDuration(span) }}</span>
                    <span class="text-fq-text-muted">· {{ spanInfo(span) }}</span>
                  </div>
                }
              </div>
            }
          }
        </div>

        <div class="rounded-xl border border-fq-border-soft bg-fq-surface p-3 md:col-span-2">
          <div class="mb-2 text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Diagnostica RTU</div>

          @if (diagnosisLoading()) {
            <div class="text-sm text-fq-text-muted">Analisi in corso…</div>
          } @else if (rtuOnline()) {
            <div class="diag-head diag-head-ok">
              <span class="diag-head-cat">Nessun guasto</span>
              <span class="diag-head-text">RTU raggiungibile: situazione compliant. La diagnostica a monte si applica solo alle RTU non pingabili.</span>
            </div>
          } @else if (diagnosis(); as d) {
            @if (d.targets?.length) {
              <div class="diag-head" [ngClass]="diagHeadClass()">
                <span class="diag-head-cat">{{ cleanText(d.categoriaLabel) }}</span>
                <span class="diag-head-text">{{ cleanText(d.diagnosi) }}</span>
              </div>

              <div class="diag-chain" aria-label="Catena di rete di sede">
                <span class="diag-node" [ngClass]="diagNodeClass(o.rtu.lastPing?.state)">
                  <fa-icon [icon]="['fas', 'microchip']" aria-hidden="true"></fa-icon>
                  <span class="diag-node-label">RTU</span>
                  <span class="diag-node-state">{{ o.rtu.lastPing?.state === 'online' ? 'ok' : 'down' }}</span>
                </span>
                @for (target of d.targets; track target.target) {
                  <span class="diag-arrow" aria-hidden="true"></span>
                  <span class="diag-node" [ngClass]="diagNodeClass(target.stato, target.note)">
                    <fa-icon [icon]="targetIcon(target.target)" aria-hidden="true"></fa-icon>
                    <span class="diag-node-label">{{ targetLabel(target.target) }}</span>
                    <span class="diag-node-state">{{ targetStatoLabel(target.stato, target.note) }}</span>
                  </span>
                }
              </div>

              <div class="mt-3 overflow-x-auto">
                <table class="w-full text-left text-xs">
                  <thead>
                    <tr class="text-fq-text-muted">
                      <th class="py-1 pr-3 font-semibold">Apparato</th>
                      <th class="py-1 pr-3 font-semibold">IP</th>
                      <th class="py-1 font-semibold">Stato</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (target of d.targets; track target.target) {
                      <tr class="border-t border-fq-border-faint">
                        <td class="py-1 pr-3">{{ targetLabel(target.target) }}</td>
                        <td class="py-1 pr-3 text-fq-text-muted">{{ target.ip || '—' }}</td>
                        <td class="py-1">
                          <span class="diag-pill" [ngClass]="diagNodeClass(target.stato, target.note)">{{ targetStatoLabel(target.stato, target.note) }}</span>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>

              <div class="mt-2 text-[11px] leading-snug text-fq-text-muted">
                RTU e firewall sono collegati allo stesso switch di sede: se lo switch non risponde non sono raggiungibili né la RTU né il firewall;
                se switch e firewall rispondono, il guasto è sulla sola RTU. I P2P (MPLS) sono a monte del firewall e indicano un problema carrier/WAN.
              </div>
            } @else {
              <div class="text-sm text-fq-text-muted">Nessuna diagnostica disponibile (RTU raggiungibile o primo cron non ancora eseguito).</div>
            }
          } @else {
            <div class="text-sm text-fq-text-muted">Diagnostica non disponibile.</div>
          }
        </div>
      </div>
    }
  }
  </fq-dialog-nav>

  <p-dialog [visible]="ticketDialogVisible()" (visibleChange)="ticketDialogVisible.set($event)"
    [header]="'Apri ticket · ' + (siteFraz() || '')" [modal]="true" [draggable]="false" [resizable]="false"
    [style]="{ width: 'min(720px, 95vw)' }" [contentStyle]="{ 'max-height': '78vh', 'overflow-y': 'auto' }"
    [baseZIndex]="2300" appendTo="body">
    @if (ticketDialogVisible()) {
      <fq-support-ticket-form [siteKey]="siteFraz()" [siteLocked]="true" (created)="onTicketCreated()"></fq-support-ticket-form>
    }
  </p-dialog>
  }
}
